<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-01 15:44:44
 * @LastEditTime : 2020-01-17 10:42:25
 * @LastEditors  : Please set LastEditors
 -->


<!--  -->
<template>
  <div>
    <div class="layer_nav">
      <div
        class="switch_btn"
        @click="_switchLayerClickHandler"
      >
        <i></i>
      </div>

      <div
        v-show="ucSetting.layerSwitchVisible"
        class="layer-pop"
      >
        <div class="layer_container"></div>
        <div class="layer-items">

          <a class="layer-item">
            <div
              class="layer_img_bg"
              @click="_switchImageLayerClickHandler"
            ></div>
            <span class="layer-tip">影像</span>
          </a>

          <a class="layer-item">
            <div
              class="layer_vector_bg"
              @click="_switchVectorLayerClickHandler"
            ></div>
            <span class="layer-tip">地图</span>
          </a>

          <a class="layer-item">
            <div
              class="layer_ter_bg"
              @click="_switchTerLayerClickHandler"
            ></div>
            <span class="layer-tip">地形</span>
          </a>

        </div>
      </div>

    </div>
  </div>

</template>

<script>
import { UCBaseLayerSwitchEvent } from "./UCBaseLayerSwitchJs.js";

export default {
  name: "UCBaseLayerSwitch",
  data() {
    return {
      ucSetting: {
        layerSwitchVisible: false
      }
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    on_switchVectorClick(callback) {
      if (callback) {
        this.$on(
          UCBaseLayerSwitchEvent.UCBaseLayerSwitch_vector_click,
          callback
        );
      }
    },

    on_switchImageClick(callback) {
      if (callback) {
        this.$on(
          UCBaseLayerSwitchEvent.UCBaseLayerSwitch_image_click,
          callback
        );
      }
    },

    on_switchTerClick(callback) {
      if (callback) {
        this.$on(UCBaseLayerSwitchEvent.UCBaseLayerSwitch_ter_click, callback);
      }
    },

    _switchVectorLayerClickHandler() {
      this.ucSetting.layerSwitchVisible = !this.ucSetting.layerSwitchVisible;

      this.$emit(UCBaseLayerSwitchEvent.UCBaseLayerSwitch_vector_click);
    },

    _switchTerLayerClickHandler() {
      this.ucSetting.layerSwitchVisible = !this.ucSetting.layerSwitchVisible;

      this.$emit(UCBaseLayerSwitchEvent.UCBaseLayerSwitch_ter_click);
    },

    _switchImageLayerClickHandler() {
      this.ucSetting.layerSwitchVisible = !this.ucSetting.layerSwitchVisible;

      this.$emit(UCBaseLayerSwitchEvent.UCBaseLayerSwitch_image_click);
    },

    _switchLayerClickHandler() {
      this.ucSetting.layerSwitchVisible = !this.ucSetting.layerSwitchVisible;
    }
  }
};
</script>
<style lang="scss" scoped>
.layer_nav {
  bottom: 100px;
  position: absolute;
  right: 23px;
  background: #fff;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.3);
  z-index: 9999;
}

.switch_btn {
  position: relative;
  z-index: 8;
  box-shadow: 0 0 0 2px #fff;
  cursor: pointer;

  i {
    background: url("../../../assets/onlineMap/icon.png") #fff;
    background-position: -527px -216px;
    width: 18px;
    height: 18px;
    display: inline-block;
    margin: 5px;
  }
}

.layer-pop {
  position: absolute;
  z-index: 9;
  right: 40px;
  top: -30px;
  background: #fff;
  border-radius: 3px;
  font-size: 13px;
  border: 10px solid #fff;
  overflow: hidden;
  box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.15);

  .layer_container {
    position: relative;
  }

  .layer-items .layer-item {
    width: 68px;
    height: 63px;
    display: inline-block;
    text-align: center;
    line-height: 20px;
    color: #333;
    position: relative;
    cursor:pointer;
  }

  .layer-items {
    white-space: nowrap;
    position: relative;
  }

  .layer-item .layer-tip {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    //   margin-left: 10px;
  }

  .layer_vector_bg {
    background: url("../../../assets/onlineMap/icon.png") #fff;
    width: 68px;
    height: 63px;
    background-position: -240px -53px;
  }

  .layer_ter_bg {
    background: url("../../../assets/onlineMap/icon.png") #fff;
    width: 68px;
    height: 63px;
    background-position: -84px -53px;
  }

  .layer_img_bg {
    background: url("../../../assets/onlineMap/icon.png") #fff;
    width: 68px;
    height: 63px;
    background-position: -163px -53px;
  }
}
</style>
